import { ROUTES } from '@analyzer/utils/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/submissions/$submissionId/'
)({
  beforeLoad({ params, search }) {
    throw redirect({ to: ROUTES.submissionOverview, params, search })
  },
})
